import { useEffect, useState } from "react";

import { providerOptions, isProviderKey } from "@smart/bridge-providers-dom";

export const useProvider = (fragment?: unknown) => {
  const [selected, selectProvider] = useState(() =>
    isProviderKey(fragment) ? fragment : undefined,
  );
  useEffect(() => {
    if (isProviderKey(fragment)) {
      selectProvider(fragment);
    }
  }, [fragment]);

  return {
    selectProvider,
    provider: selected ? providerOptions[selected] : undefined,
  };
};
